"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Refresh = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Refresh = ({ fill = "#E6E6E6", size = 16, ...rest }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true, fill: fill, viewBox: "0 0 16 16", ...rest },
    react_1.default.createElement("path", { d: "M8,1a6.88,6.88,0,0,1,5.4,2.6L15,2V7H10l1.7-1.7A4.42,4.42,0,0,0,8,3.4,4.81,4.81,0,0,0,3.4,7.1H1A7.18,7.18,0,0,1,8,1Z" }),
    react_1.default.createElement("path", { d: "M1,9H6L4.3,10.7A4.42,4.42,0,0,0,8,12.6a4.81,4.81,0,0,0,4.6-3.7H15a7,7,0,0,1-6.9,6,6.88,6.88,0,0,1-5.4-2.6L1,14Z" })));
exports.Refresh = Refresh;
//# sourceMappingURL=Refresh.js.map